exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-raised-button {\r\n    margin: 20%\r\n}\r\n\r\n.cancel-btton {\r\n    background-color: #c9c9c9;\r\n}\r\n\r\n.confirm-button {\r\n    background-color: #607d8b;\r\n}\r\n\r\n.comments {\r\n    min-width: 450px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();